// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3j3zK","colMin":"styles_colMin__20Wtw"};